import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="#bcd1f7" viewBox="0 0 320 512" {...props}><path d="M246.5 216.6h-173c-12 0-18-17.4-9.5-27.6l86.5-137.7c5.2-6.3 13.8-6.3 19 0L256.1 189c8.4 10.3 2.4 27.6-9.6 27.6zM73.5 295.4h173.1c12 0 18 17.4 9.5 27.6l-86.5 137.7c-5.2 6.3-13.8 6.3-19 0L63.9 323c-8.4-10.3-2.4-27.6 9.6-27.6z" /></svg>);